<template>
  <section class="page-reviews">
    <!-- HEADER -->
    <section class="hero-small" :style="{ backgroundImage: `linear-gradient(180deg, rgba(10, 10, 10, 0.6) 0%, rgba(32, 32, 32, 0.2) 100%), url(${medias ? medias.find((media) => media.type === 'OUTSIDE').url : '' })` }">
      <div>
        <h1>Maisons Alysia - {{ agency.name }}, <br>les avis de nos clients</h1>
      </div>
    </section>
    <section class="reviews">
      <div class="grid-container">
        <div class="list" v-if="reviews && infos">
          <div>
            <div class="resume">
              <h2>Les avis certifiés de nos clients</h2>
              <p>
                Chez <router-link :to="{ name: 'agency', params: { slug: agency.slug }}">Maisons Alysia - {{ agency.name }}</router-link>, ce sont <strong>nos clients</strong> qui parlent le mieux de leur expérience.
              </p>
              <p>
                Découvrez leurs <strong>avis vérifiés et authentiques</strong> sur la construction de leur maison. Ces retours nous permettent de progresser chaque jour, d’ajuster nos services et de rester à l’écoute de vos besoins.
              </p>
              <p>
                Tous les avis sont vérifiés par un tiers de confiance, <strong>Immodvisor</strong>, pour garantir leur fiabilité. Parcourez leurs témoignages pour vous faire une idée concrète de notre accompagnement.
              </p>
              <review-certification v-if="agency" :text="agency.name" :rating="infos.agencyRating" />
              <div class="tags">
                <span>
                  <strong>{{ infos.agencyReviewsCount }} </strong>
                  <small>avis certifiés</small>
                </span>
                <span>
                  <small v-if="agency" >{{ agency.name }}</small>
                </span>
                <span>
                  <small>Excellent </small>
                  <strong> ⭐️ ⭐️ ⭐️ ⭐️ ⭐️</strong>
                </span>
              </div>
            </div>
            <review-card v-for="review in reviews.slice(0,Math.floor(reviews.length / 2))" :key="review.id" :review="review" :agency="agency"/>
          </div>
          <div>
            <review-card v-for="review in reviews.slice(Math.floor(reviews.length / 2), reviews.length)" :key="review.id" :review="review" :agency="agency"/>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import agencyApi from '@/services/api/agency';
import ReviewCard from './ReviewCard.vue';
import ReviewCertification from './ReviewCertification.vue';

export default {
  name: 'page-reviews',
  components: {
    ReviewCard,
    ReviewCertification,
  },
  data() {
    return {
      agency: null,
      infos: null,
      medias: null,
      reviews: null,
    };
  },
  async created() {
    await this.getAgency();
    await this.getReviews();
    await this.getMedias();
  },
  methods: {
    async getAgency() {
      try {
        const response = await agencyApi.getBySlugName(this.$route.params.slugName);
        this.agency = response;
      } catch (error) {
        this.$notification.show({ text: 'Une erreur s’est produite.' });
        throw error;
      }
    },
    async getMedias() {
      try {
        const response = await agencyApi.getAgencyMedias(this.agency.agencyId);
        this.medias = response;
        this.mediasLoaded = true;
      } catch (error) {
        throw error;
      }
    },
    async getReviews() {
      try {
        const response = await agencyApi.getAgencyReviews(this.agency.agencyId);
        this.infos = {
          agencyRating: response.agencyRating,
          agencyReviewsCount: response.agencyReviewsCount,
          brandRating: response.brandRating,
          brandReviewsCount: response.brandReviewsCount,
        };
        this.reviews = response.reviews.filter((r) => r.rating > 2);
      } catch (error) {
        this.$notification.show({ text: 'Une erreur s’est produite.' });
        throw error;
      }
    },
  },
};
</script>

<style lang="sass">
.page-reviews
  background: $medium-bg
  .hero-small
    @include hero-small
    background-image: linear-gradient(180deg, rgba(10, 10, 10, 0.6) 0%, rgba(32, 32, 32, 0.2) 100%), url(~@/assets/img/pages/contemporary-house-1.jpg)
    h1
      text-wrap-style: pretty
  .reviews
    padding: 40px 0 100px
    background: linear-gradient(-15deg, lighten($primary, 20%), lighten($home-bg, 20%))
  .list
    display: flex
    gap: 30px
    padding: 40px
    @media (max-width: 768px)
      flex-direction: column
    > div
      display: flex
      flex: 1
      flex-direction: column
      gap: 30px
    .resume
      position: relative
      display: flex
      flex-direction: column
      gap: 20px
      padding-bottom: 10px
      h2
        font-size: 3rem
        line-height: 120%
        color: $primary
        text-wrap: balance
      p
        color: $black
        a
          text-decoration: none
          color: $black
          font-weight: bold
          font-size: 1rem
      .tags
        display: flex
        gap: 10px
        margin: 10px 0 20px
        @media (max-width: 768px)
          flex-direction: column
        > span
          padding: 5px 15px
          border-radius: 20px
          background: $primary
          color: white
          font-size: 0.9rem
          text-align: center
          &:last-child
            background: $colored-bg
          &:first-child
            background: #fd4e2a
</style>
